export const sp = '\u0001';
export const gtsp = 'gt0001';

export interface SDKConfig {
    content_group: string;
    content_type: string;
    userId: string;
    islogin: boolean;
    deviceId?: string;      // gt_p (HttpOnly)
    sessionId?: string;     // gt_s (HttpOnly)
    [key: string]: any;
}

export interface SDKCommonParams {
    uid?: string;
    devid?: string;
    platform: string;
    browsetype: string;
    islogin: number;
    localtime: number;
    timezone: string;
    osver: string;
}

export interface GTCommonParams {
    event_name: string;
    content_group?: string;
    content_type?: string;
    user_pseudo_id?: string;
    session_id?: string;
}

export interface GTParams extends GTCommonParams {
    [key: string]: any;
}

export interface EventData {
    eventName: string;
    params: Record<string, any>;
    source?: string;
}

